"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _theme = _interopRequireDefault(require("./theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  * {\n    box-sizing: border-box;\n    font-weight: inherit;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  html {\n    -ms-text-size-adjust: 100%;\n    -moz-text-size-adjust: 100%;\n    -webkit-text-size-adjust: 100%\n  }\n\n  html,\n  body {\n    min-height: 100%;\n    min-width: 100%;\n  }\n\n  body {\n    padding: 0;\n    margin: 0;\n    font-size: ", "px;\n    font-family: ", ";\n    line-height: 1.375;\n    position: relative;\n    height: 100%;\n    max-height: 100%;\n    width: 100%;\n  }\n\n  a {\n    color: currentColor;\n    text-decoration: none;\n  }\n\n  textarea {\n    resize: none;\n  }\n\n  strong {\n    font-weight: bold;\n  }\n\n  pre,\n  code,\n  kbd {\n    font-family: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  @font-face {\n    font-family: 'Phantom Sans';\n    src: url('https://hackclub.com/fonts/Phantom_Sans_0.4/Regular.woff')\n        format('woff'),\n      url('https://hackclub.com/fonts/Phantom_Sans_0.4/Regular.woff2')\n        format('woff2');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n  }\n  @font-face {\n    font-family: 'Phantom Sans';\n    src: url('https://hackclub.com/fonts/Phantom_Sans_0.4/Bold.woff')\n        format('woff'),\n      url('https://hackclub.com/fonts/Phantom_Sans_0.4/Bold.woff2')\n        format('woff2');\n    font-weight: bold;\n    font-style: normal;\n    font-display: swap;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var fontsCss = (0, _styledComponents.css)(_templateObject());
(0, _styledComponents.injectGlobal)(_templateObject2(), _theme["default"].fontSizes[2], _theme["default"].font, _theme["default"].mono);

var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
      webfonts = _ref.webfonts,
      props = _objectWithoutProperties(_ref, ["theme", "webfonts"]);

  if (webfonts) (0, _styledComponents.injectGlobal)([], fontsCss);
  return _react["default"].createElement(_styledComponents.ThemeProvider, _extends({
    theme: theme
  }, props, {
    children: _react["default"].createElement(_react.Fragment, null, props.children)
  }));
};

ThemeProvider.propTypes = {
  theme: _propTypes["default"].object,
  webfonts: _propTypes["default"].bool
};
ThemeProvider.defaultProps = {
  theme: _theme["default"],
  webfonts: false
};
var _default = ThemeProvider;
exports["default"] = _default;